import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-app-cooking-story-popup',
  templateUrl: './app-cooking-story-popup.component.html',
  styles: [
    `
      .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        height: 105px;
      }
      .message-title {
        font-family: 'Vazir-Medium' !important;
        font-size: 18px;
        margin: 0;
      }
      .dimiss {
        font-family: 'Vazir-Bold' !important;
        font-size: 18px;
        color: #2294e6;
      }
    `,
  ],
})
export class AppCookingStoryPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      message: string;
    },
    private bottomSheetRef: MatBottomSheetRef<AppCookingStoryPopupComponent>,
    private matBottomSheet: MatBottomSheet
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.dimiss();
    }, 3000);
  }
  dimiss() {
    this.bottomSheetRef.dismiss();
  }
}
